// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3CpTN","emails":"CreateEditClinics_emails__2vHK0","emailTagLabel":"CreateEditClinics_emailTagLabel__2oJaa"};